export { default as ThreeDStockContentImageScaleButton } from './ThreeDStockContentImageScaleButton';
